// import axios from 'axios';
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { baseUrl } from '../../config/config';
// export const FETCH_BILLS_REQUEST = 'FETCH_BILLS_REQUEST';
// export const FETCH_BILLS_SUCCESS = 'FETCH_BILLS_SUCCESS';
// export const FETCH_BILLS_ERROR = 'FETCH_BILLS_ERROR';

// export const ADD_BILL_REQUEST = 'ADD_BILL_REQUEST';
// export const ADD_BILL_SUCCESS = 'ADD_BILL_SUCCESS';
// export const ADD_BILL_ERROR = 'ADD_BILL_ERROR';

// export const EDIT_BILL_REQUEST = 'EDIT_BILL_REQUEST';
// export const EDIT_BILL_SUCCESS = 'EDIT_BILL_SUCCESS';
// export const EDIT_BILL_ERROR = 'EDIT_BILL_ERROR';

// export const UPDATE_BILL_STATUS_REQUEST = 'UPDATE_BILL_STATUS_REQUEST';
// export const UPDATE_BILL_STATUS_SUCCESS = 'UPDATE_BILL_STATUS_SUCCESS';
// export const UPDATE_BILL_STATUS_ERROR = 'UPDATE_BILL_STATUS_ERROR';

// export const UPDATE_MASSBILLS_STATUS_REQUEST = 'UPDATE_MASSBILLS_STATUS_REQUEST';
// export const UPDATE_MASSBILLS_STATUS_SUCCESS = 'UPDATE_MASSBILLS_STATUS_SUCCESS';
// export const UPDATE_MASSBILLS_STATUS_ERROR = 'UPDATE_MASSBILLS_STATUS_ERROR';

// export const UPDATE_MASSBILLS_ROLLBACK_REQUEST = 'UPDATE_MASSBILLS_ROLLBACK_REQUEST';
// export const UPDATE_MASSBILLS_ROLLBACK_SUCCESS = 'UPDATE_MASSBILLS_ROLLBACK_SUCCESS';
// export const UPDATE_MASSBILLS_ROLLBACK_ERROR = 'UPDATE_MASSBILLS_ROLLBACK_ERROR';

// export const DELETE_BILL_REQUEST = 'DELETE_BILL_REQUEST';
// export const DELETE_BILL_SUCCESS = 'DELETE_BILL_SUCCESS';
// export const DELETE_BILL_ERROR = 'DELETE_BILL_ERROR';

// export const UPDATE_BILL_FLAG_REQUEST = 'UPDATE_BILL_FLAG_REQUEST';
// export const UPDATE_BILL_FLAG_SUCCESS = 'UPDATE_BILL_FLAG_SUCCESS';
// export const UPDATE_BILL_FLAG_ERROR = 'UPDATE_BILL_FLAG_ERROR';

// export const FETCH_OVERDUE_BILLS_REQUEST ='FETCH_OVERDUE_BILLS_REQUEST';
// export const FETCH_OVERDUE_BILLS_SUCCESS ='FETCH_OVERDUE_BILLS_SUCCESS';
// export const FETCH_OVERDUE_BILLS_ERROR = 'FETCH_OVERDUE_BILLS_ERROR';
// const getToken = () => {
//   const resdata = JSON.parse(localStorage.getItem('resdata'));
//   return resdata ? resdata.token : null;
// };
// export const fetchBillsRequest = () => ({
//   type: FETCH_BILLS_REQUEST
// });
// export const fetchBillsSuccess = (bills) => ({
//   type: FETCH_BILLS_SUCCESS,
//   payload: bills
// });
// export const fetchBillsFailure = (error) => ({
//   type: FETCH_BILLS_ERROR,
//   payload: error.message
// });



// export const fetchOverdueBillsRequest = () => ({
//   type: FETCH_OVERDUE_BILLS_REQUEST
// });

// export const fetchOverdueBillsSuccess = (data) => ({
//   type: FETCH_OVERDUE_BILLS_SUCCESS,
//   payload: data
// });

// export const fetchOverdueBillsFailure = (error) => ({
//   type: FETCH_OVERDUE_BILLS_ERROR,
//   payload: error
// });


// // Updated fetchBills function with pagination support
// export const fetchBills = (page = 1, limit = 10, filters = {}) => {
//   return async (dispatch) => {
//     dispatch(fetchBillsRequest());
//     try {
//       // Build query parameters
//       let queryParams = `page=${page}&limit=${limit}`;
      
//       // Add filters to query if provided
//       if (filters.selectedMonthYear) {
//         queryParams += `&selectedMonthYear=${encodeURIComponent(filters.selectedMonthYear)}`;
//       }
      
//       if (filters.consumerNumber) {
//         queryParams += `&consumerNumber=${encodeURIComponent(filters.consumerNumber)}`;
//       }
      
//       if (filters.wardName) {
//         queryParams += `&wardName=${encodeURIComponent(filters.wardName)}`;
//       }
      
//       const response = await axios.get(`${baseUrl}/getBills?${queryParams}`);
//       dispatch(fetchBillsSuccess(response.data));
//     } catch (error) {
//       dispatch(fetchBillsFailure(error.message));
//     }
//   };
// };

// //before server pagination
// // export const fetchBills = () => {
// //   return async (dispatch) => {
// //     dispatch(fetchBillsRequest());
// //     try {
// //       const response = await axios.get(`${baseUrl}/getBills`);
// //       dispatch(fetchBillsSuccess(response.data));
// //     } catch (error) {
// //       dispatch(fetchBillsFailure(error.message));
// //     }
// //   };
// // };

// // -------------------------------------------------------------

// // export const fetchOverdueBills = (page = 1,limit = 50,selectedMonthYear) => {
// //   return async (dispatch) => {
// //     dispatch(fetchOverdueBillsRequest());
// //     try {
// //       const response = await axios.get(`${baseUrl}/getBillsOverdue?page=${page}&limit=${limit}`);
// //       dispatch(fetchOverdueBillsSuccess(response.data));
// //     } catch (error) {
// //       dispatch(fetchOverdueBillsFailure(error.message));
// //     }
// //   };
// // };

// // -----------------------------------------------------

// export const fetchOverdueBills = (page = 1, limit = 50, selectedMonthYear) => {
//   return async (dispatch) => {
//     dispatch(fetchOverdueBillsRequest());
//     try {
//       // Build query parameters
//       let queryParams = `page=${page}&limit=${limit}`;
      
//       // Add selectedMonthYear to query if provided
//       if (selectedMonthYear) {
//         queryParams += `&selectedMonthYear=${encodeURIComponent(selectedMonthYear)}`;
//       }
      
//       const response = await axios.get(`${baseUrl}/getBillsOverdue?${queryParams}`);
//       dispatch(fetchOverdueBillsSuccess(response.data));
//     } catch (error) {
//       dispatch(fetchOverdueBillsFailure(error.message));
//     }
//   };
// };


// // Dynamic pagination fetchBills function




// // export const fetchBills = (paginationParams = {}) => {
// //   return async (dispatch) => {
// //     dispatch(fetchBillsRequest());
// //     try {
// //       // Build query parameters dynamically
// //       const queryParams = new URLSearchParams({
// //         page: paginationParams.page || 0,
// //         pageSize: paginationParams.pageSize || 100,
// //         ...(paginationParams.consumerNumber && { consumerNumber: paginationParams.consumerNumber }),
// //         ...(paginationParams.ward && { ward: paginationParams.ward }),
// //         ...(paginationParams.monthYear && { monthYear: paginationParams.monthYear }),
// //         ...(paginationParams.userRole && { userRole: paginationParams.userRole }),
// //         ...(paginationParams.userWard && { userWard: paginationParams.userWard }),
// //       });

// //       const response = await axios.get(`${baseUrl}/getBills?${queryParams}`);
// //       dispatch(fetchBillsSuccess(response.data));
// //     } catch (error) {
// //       dispatch(fetchBillsFailure(error.message));
// //     }
// //   };
// // };


// export const addBillRequest = () => ({
//   type: ADD_BILL_REQUEST,
// })
// export const addBillSuccess = (bill) => ({
//   type: ADD_BILL_SUCCESS,
//   payload: bill
// })
// export const addBillFailure = (error) => ({
//   type: ADD_BILL_ERROR,
//   payload: error.message
// })
// export const editBillRequest = () => ({
//   type: EDIT_BILL_REQUEST,
// });
// export const editBillSuccess = (bill) => ({
//   type: EDIT_BILL_SUCCESS,
//   payload: bill,
// });
// export const editBillFailure = (error) => ({
//   type: EDIT_BILL_ERROR,
//   payload: error.message,
// });
// export const editBill = (billId, billData) => {
//   return async (dispatch) => {
//     dispatch(editBillRequest());
//     try {
//       const token = getToken();
//       const response = await axios.put(`${baseUrl}/editBill/${billId}`, billData, {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       });
//       dispatch(editBillSuccess(response.data.bill));
//       toast.success("Bill Updated Successfully", { position: "top-center" });
//     } catch (error) {
//       dispatch(editBillFailure(error.response?.data?.message || "Error updating bill"));
//       toast.error(error.response?.data?.message || "Error updating bill", { position: "top-center" });
//     }
//   };
// };
// export const updateBillFlagRequest = () => ({
//   type: UPDATE_BILL_FLAG_REQUEST,
// })
// export const updateBillFlagSuccess = (bill) => ({
//   type: UPDATE_BILL_FLAG_SUCCESS,
//   payload: bill
// })
// export const updateBillFlagFailure = (error) => ({
//   type: UPDATE_BILL_FLAG_ERROR,
//   payload: error.message
// })

// export const addBill = (billData) => {
//   return async (dispatch) => {
//     dispatch(addBillRequest());
//     try {
//       const token = getToken();
//       const response = await axios.post(`${baseUrl}/addBill`, billData
//         , {
//         // headers: {
//         //   Authorization: `Bearer ${token}`
//         // }
//         headers: {
//           vvcmcsaaviinfinet: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3YTZmYmI3NjZkMWYxNWY1OGM0NTNhYiIsInJvbGUiOiJTdXBlciBBZG1pbiIsImlhdCI6MTczODk5ODIyMywiZXhwIjoxNzQxNTkwMjIzfQ.YQRt7Kj4-eRejrs-G073tvzLdM_9oQDOYuQYmxSWsgs"
//         }
//       }
//       );
//       dispatch(addBillSuccess(response.data.bill))
//       console.log("response.data.bill",response.data.bill)
//       toast.success(response?.data?.bill?.status, { position: "top-center" });
//       dispatch(fetchBills());
//     } catch (error) {
//       dispatch(addBillFailure(error));
//       toast.error(error.response?.data?.message || "Error adding lightbill", { position: "top-center" });
//     }
//   }
// }


// // export const addBill = (billData) => {
// //   return async (dispatch) => {
// //     dispatch(addBillRequest());
// //     try {
// //       // const token = getToken();
// //       const response = await axios.post(`${baseUrl}/addBill`, billData, {
// //         headers: {
// //           vvcmc: "saavi@infinet"
// //         }
// //       });

// //       console.log("response.data.bill", response.data.bill);

// //       if (Array.isArray(response.data.bill)) {
// //         const hasSuccess = response.data.bill.some(item => item.status === "SUCCESS");
// //         const hasFailure = response.data.bill.some(item => item.status === "FAILURE");

// //         if (hasSuccess) {
// //           dispatch(addBillSuccess(response.data.bill.filter(item => item.status === "SUCCESS")));
// //           toast.success("Bill Added Successfully", { position: "top-center" });
// //           dispatch(fetchBills());
// //         }

// //         if (hasFailure) {
// //           response.data.bill
// //             .filter(item => item.status === "FAILURE")
// //             .forEach(error => {
// //               toast.error(error.errorMessage || "Error processing bill", { position: "top-center" });
// //             });
// //         }
// //       } else {
// //         throw new Error("Unexpected response format");
// //       }
      
// //     } catch (error) {
// //       dispatch(addBillFailure(error));
// //       toast.error(error.response?.data?.message || "Error adding lightbill", { position: "top-center" });
// //     }
// //   };
// // };


// export const updateBillStatusAction = (id, approvedStatus, paymentStatus, yesno) => async (dispatch) => {
//   try {
//     const token = getToken();
//     const response = await axios.put(`${baseUrl}/updateBillStatus`, {
//       id, approvedStatus, paymentStatus, yesno
//     }, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       }
//     });
//     dispatch({
//       type: 'UPDATE_BILL_STATUS_SUCCESS',
//       payload: { id, approvedStatus, paymentStatus, yesno },
//     });
//     dispatch(fetchBills());
//   } catch (error) {
//     dispatch({
//       type: 'UPDATE_BILL_STATUS_FAIL',
//       payload: error.message,
//     });
//   }
// };
// export const massBillApprovalsAction = (bills) => async (dispatch) => {
//   dispatch({ type: UPDATE_MASSBILLS_STATUS_REQUEST });

//   try {
//     const token = getToken();
//     const response = await axios.put(`${baseUrl}/massUpdateBillStatus`, { bills }, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       }
//     });

//     if (response.status === 200) {
//       dispatch({
//         type: UPDATE_MASSBILLS_STATUS_SUCCESS
//       });
//       toast.success("Mass bill approvals updated successfully", { position: "top-center" });
//       dispatch(fetchBills());
//     } else {
//       throw new Error('Failed to update mass bill approvals');
//     }

//   } catch (error) {
//     dispatch({
//       type: UPDATE_MASSBILLS_STATUS_ERROR,
//       payload: error.message,
//     });
//     toast.error(error.message, { position: "top-center" });
//   }
// };
// export const massBillRollbackApprovalsAction = (bills) => async (dispatch) => {
//   dispatch({ type: UPDATE_MASSBILLS_ROLLBACK_REQUEST });
//   try {
//     const token = getToken();
//     const response = await axios.put(`${baseUrl}/reverseMassBillStatus`, { bills }, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       }
//     });
//     if (response.status === 200) {
//       dispatch({
//         type: UPDATE_MASSBILLS_ROLLBACK_SUCCESS
//       });
//       toast.success("Mass bills Rollback updated successfully", { position: "top-center" });
//       dispatch(fetchBills());
//     } else {
//       throw new Error('Failed to update mass bill approvals');
//     }
//   } catch (error) {
//     dispatch({
//       type: UPDATE_MASSBILLS_ROLLBACK_ERROR,
//       payload: error.message,
//     });
//     toast.error(error.message, { position: "top-center" });
//   }
// };

// export const updateFlagStatus = (billId, flagStatus) => async (dispatch) => {
//   dispatch(updateBillFlagRequest());
//   try {
//     const token = getToken();
//     const response = await axios.put(`${baseUrl}/updateFlagStatus`, {
//       billId,
//       flagStatus
//     }, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       }
//     });
//     dispatch(updateBillFlagSuccess({ billId, flagStatus }));
//     toast.success("Bill flag status updated successfully", { position: "top-center" });
//   } catch (error) {
//     dispatch(updateBillFlagFailure(error.message));
//     toast.error(error.response?.data?.message || "Error updating bill flag status", { position: "top-center" });
//   }
// };
// export const deleteBillRequest = () => ({
//   type: DELETE_BILL_REQUEST,
// });
// export const deleteBillSuccess = (bill_id) => ({
//   type: DELETE_BILL_SUCCESS,
//   payload: bill_id,
// });
// export const deleteBillFailure = (error) => ({
//   type: DELETE_BILL_ERROR,
//   payload: error.message,
// });
// export const deleteBill = (bill_id) => {
//   return async (dispatch) => {
//     dispatch(deleteBillRequest());
//     try {
//       const token = getToken();
//       const response = await axios.delete(`${baseUrl}/bill/${bill_id}`, {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       })
//       dispatch(deleteBillSuccess(bill_id));
//       toast.success("Bill deleted successfully", { position: "top-center" });
//     } catch (error) {
//       dispatch(deleteBillFailure(error.message));
//     }
//   };
// };



// ===================================
// 1 oct 2025


import axios from 'axios';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from '../../config/config';
export const FETCH_BILLS_REQUEST = 'FETCH_BILLS_REQUEST';
export const FETCH_BILLS_SUCCESS = 'FETCH_BILLS_SUCCESS';
export const FETCH_BILLS_ERROR = 'FETCH_BILLS_ERROR';

export const ADD_BILL_REQUEST = 'ADD_BILL_REQUEST';
export const ADD_BILL_SUCCESS = 'ADD_BILL_SUCCESS';
export const ADD_BILL_ERROR = 'ADD_BILL_ERROR';

export const EDIT_BILL_REQUEST = 'EDIT_BILL_REQUEST';
export const EDIT_BILL_SUCCESS = 'EDIT_BILL_SUCCESS';
export const EDIT_BILL_ERROR = 'EDIT_BILL_ERROR';

export const UPDATE_BILL_STATUS_REQUEST = 'UPDATE_BILL_STATUS_REQUEST';
export const UPDATE_BILL_STATUS_SUCCESS = 'UPDATE_BILL_STATUS_SUCCESS';
export const UPDATE_BILL_STATUS_ERROR = 'UPDATE_BILL_STATUS_ERROR';

export const UPDATE_MASSBILLS_STATUS_REQUEST = 'UPDATE_MASSBILLS_STATUS_REQUEST';
export const UPDATE_MASSBILLS_STATUS_SUCCESS = 'UPDATE_MASSBILLS_STATUS_SUCCESS';
export const UPDATE_MASSBILLS_STATUS_ERROR = 'UPDATE_MASSBILLS_STATUS_ERROR';

export const UPDATE_MASSBILLS_ROLLBACK_REQUEST = 'UPDATE_MASSBILLS_ROLLBACK_REQUEST';
export const UPDATE_MASSBILLS_ROLLBACK_SUCCESS = 'UPDATE_MASSBILLS_ROLLBACK_SUCCESS';
export const UPDATE_MASSBILLS_ROLLBACK_ERROR = 'UPDATE_MASSBILLS_ROLLBACK_ERROR';

export const DELETE_BILL_REQUEST = 'DELETE_BILL_REQUEST';
export const DELETE_BILL_SUCCESS = 'DELETE_BILL_SUCCESS';
export const DELETE_BILL_ERROR = 'DELETE_BILL_ERROR';

export const UPDATE_BILL_FLAG_REQUEST = 'UPDATE_BILL_FLAG_REQUEST';
export const UPDATE_BILL_FLAG_SUCCESS = 'UPDATE_BILL_FLAG_SUCCESS';
export const UPDATE_BILL_FLAG_ERROR = 'UPDATE_BILL_FLAG_ERROR';

export const FETCH_OVERDUE_BILLS_REQUEST ='FETCH_OVERDUE_BILLS_REQUEST';
export const FETCH_OVERDUE_BILLS_SUCCESS ='FETCH_OVERDUE_BILLS_SUCCESS';
export const FETCH_OVERDUE_BILLS_ERROR = 'FETCH_OVERDUE_BILLS_ERROR';


export const SET_ALL_BILLS_FOR_REPORT = "SET_ALL_BILLS_FOR_REPORT";

const getToken = () => {
  const resdata = JSON.parse(localStorage.getItem('resdata'));
  return resdata ? resdata.token : null;
};
export const fetchBillsRequest = () => ({
  type: FETCH_BILLS_REQUEST
});
export const fetchBillsSuccess = (bills) => ({
  type: FETCH_BILLS_SUCCESS,
  payload: bills
});
export const fetchBillsFailure = (error) => ({
  type: FETCH_BILLS_ERROR,
  payload: error.message
});



export const fetchOverdueBillsRequest = () => ({
  type: FETCH_OVERDUE_BILLS_REQUEST
});

export const fetchOverdueBillsSuccess = (data) => ({
  type: FETCH_OVERDUE_BILLS_SUCCESS,
  payload: data
});

export const fetchOverdueBillsFailure = (error) => ({
  type: FETCH_OVERDUE_BILLS_ERROR,
  payload: error
});



// export const fetchBills = (page = 1, limit = 10, filters = {}) => {
//   return async (dispatch) => {
//     dispatch(fetchBillsRequest());
//     try {
//       // If any filter is applied, fetch all records from page 1
//       let effectiveLimit = limit;
//       let effectivePage = page;

//       if (filters.selectedMonthYear || filters.consumerNumber || filters.wardName) {
//         // effectiveLimit = 10000; // Set a very high limit to get all bills
//         effectivePage = 1; // Always fetch from page 1 when filters are applied
//       }

//       let queryParams = `page=${effectivePage}&limit=${effectiveLimit}`;

//       if (filters.selectedMonthYear) {
//         queryParams += `&selectedMonthYear=${encodeURIComponent(filters.selectedMonthYear)}`;
//       }

//       if (filters.consumerNumber) {
//         queryParams += `&consumerNumber=${encodeURIComponent(filters.consumerNumber)}`;
//       }

//       if (filters.wardName) {
//         queryParams += `&wardName=${encodeURIComponent(filters.wardName)}`;
//       }

//       const response = await axios.get(`${baseUrl}/getBills?${queryParams}`);
//       dispatch(fetchBillsSuccess(response.data));
//     } catch (error) {
//       dispatch(fetchBillsFailure(error.message));
//     }
//   };
// };




export const fetchBills = (page = 1, limit = 10000, filters = {}, fetchAll = false) => {
 return async (dispatch) => {
 dispatch(fetchBillsRequest());
 try {
 // If fetchAll is true, set a very high limit to get all records
 let effectiveLimit = fetchAll ? 10000 : limit;
 let effectivePage = fetchAll ? 1 : page;

 let queryParams = `page=${effectivePage}&limit=${effectiveLimit}`;

 if (filters.selectedMonthYear) {
 queryParams += `&selectedMonthYear=${encodeURIComponent(filters.selectedMonthYear)}`;
 }

 if (filters.consumerNumber) {
 queryParams += `&consumerNumber=${encodeURIComponent(filters.consumerNumber)}`;
 }

 if (filters.wardName) {
 queryParams += `&wardName=${encodeURIComponent(filters.wardName)}`;
 }

 const response = await axios.get(`${baseUrl}/getBills?${queryParams}`);


 dispatch(fetchBillsSuccess(response.data));
// dispatch(fetchBillsSuccess({
//   ...response.data,
//   fetchAll
// }))


if (fetchAll) {
  dispatch(setAllBillsForReport(response.data.bills));
}

 } catch (error) {
 dispatch(fetchBillsFailure(error.message));
 }
 };
};



export const fetchOverdueBills = (page = 1, limit = 50, selectedMonthYear) => {
  return async (dispatch) => {
    dispatch(fetchOverdueBillsRequest());
    try {
      // If selectedMonthYear is provided, fetch all records from page 1
      let effectiveLimit = limit;
      let effectivePage = page;

      if (selectedMonthYear) {
        effectiveLimit = 10000; // Set a very high limit to get all overdue bills for the selected month
        effectivePage = 1; // Always fetch from page 1 when filter is applied
      }

      let queryParams = `page=${effectivePage}&limit=${effectiveLimit}`;
      if (selectedMonthYear) {
        queryParams += `&selectedMonthYear=${encodeURIComponent(selectedMonthYear)}`;
      }

      const response = await axios.get(`${baseUrl}/getBillsOverdue?${queryParams}`);
      dispatch(fetchOverdueBillsSuccess(response.data));
    } catch (error) {
      dispatch(fetchOverdueBillsFailure(error.message));
    }
  };
};

export const addBillRequest = () => ({
  type: ADD_BILL_REQUEST,
})
export const addBillSuccess = (bill) => ({
  type: ADD_BILL_SUCCESS,
  payload: bill
})
export const addBillFailure = (error) => ({
  type: ADD_BILL_ERROR,
  payload: error.message
})
export const editBillRequest = () => ({
  type: EDIT_BILL_REQUEST,
});
export const editBillSuccess = (bill) => ({
  type: EDIT_BILL_SUCCESS,
  payload: bill,
});
export const editBillFailure = (error) => ({
  type: EDIT_BILL_ERROR,
  payload: error.message,
});
export const editBill = (billId, billData) => {
  return async (dispatch) => {
    dispatch(editBillRequest());
    try {
      const token = getToken();
      const response = await axios.put(`${baseUrl}/editBill/${billId}`, billData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      dispatch(editBillSuccess(response.data.bill));
      toast.success("Bill Updated Successfully", { position: "top-center" });
    } catch (error) {
      dispatch(editBillFailure(error.response?.data?.message || "Error updating bill"));
      toast.error(error.response?.data?.message || "Error updating bill", { position: "top-center" });
    }
  };
};
export const updateBillFlagRequest = () => ({
  type: UPDATE_BILL_FLAG_REQUEST,
})
export const updateBillFlagSuccess = (bill) => ({
  type: UPDATE_BILL_FLAG_SUCCESS,
  payload: bill
})
export const updateBillFlagFailure = (error) => ({
  type: UPDATE_BILL_FLAG_ERROR,
  payload: error.message
})

export const addBill = (billData) => {
  return async (dispatch) => {
    dispatch(addBillRequest());
    try {
      const token = getToken();
      const response = await axios.post(`${baseUrl}/addBill`, billData
        , {
        // headers: {
        //   Authorization: `Bearer ${token}`
        // }
        headers: {
          vvcmcsaaviinfinet: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3YTZmYmI3NjZkMWYxNWY1OGM0NTNhYiIsInJvbGUiOiJTdXBlciBBZG1pbiIsImlhdCI6MTczODk5ODIyMywiZXhwIjoxNzQxNTkwMjIzfQ.YQRt7Kj4-eRejrs-G073tvzLdM_9oQDOYuQYmxSWsgs"
        }
      }
      );
      dispatch(addBillSuccess(response.data.bill))
      console.log("response.data.bill",response.data.bill)
      toast.success(response?.data?.bill?.status, { position: "top-center" });
      dispatch(fetchBills());
    } catch (error) {
      dispatch(addBillFailure(error));
      toast.error(error.response?.data?.message || "Error adding lightbill", { position: "top-center" });
    }
  }
}

export const updateBillStatusAction = (id, approvedStatus, paymentStatus, yesno) => async (dispatch) => {
  try {
    const token = getToken();
    const response = await axios.put(`${baseUrl}/updateBillStatus`, {
      id, approvedStatus, paymentStatus, yesno
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    dispatch({
      type: 'UPDATE_BILL_STATUS_SUCCESS',
      payload: { id, approvedStatus, paymentStatus, yesno },
    });
    dispatch(fetchBills());
  } catch (error) {
    dispatch({
      type: 'UPDATE_BILL_STATUS_FAIL',
      payload: error.message,
    });
  }
};
export const massBillApprovalsAction = (bills) => async (dispatch) => {
  dispatch({ type: UPDATE_MASSBILLS_STATUS_REQUEST });

  try {
    const token = getToken();
    const response = await axios.put(`${baseUrl}/massUpdateBillStatus`, { bills }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (response.status === 200) {
      dispatch({
        type: UPDATE_MASSBILLS_STATUS_SUCCESS
      });
      toast.success("Mass bill approvals updated successfully", { position: "top-center" });
      dispatch(fetchBills());
    } else {
      throw new Error('Failed to update mass bill approvals');
    }

  } catch (error) {
    dispatch({
      type: UPDATE_MASSBILLS_STATUS_ERROR,
      payload: error.message,
    });
    toast.error(error.message, { position: "top-center" });
  }
};
export const massBillRollbackApprovalsAction = (bills) => async (dispatch) => {
  dispatch({ type: UPDATE_MASSBILLS_ROLLBACK_REQUEST });
  try {
    const token = getToken();
    const response = await axios.put(`${baseUrl}/reverseMassBillStatus`, { bills }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (response.status === 200) {
      dispatch({
        type: UPDATE_MASSBILLS_ROLLBACK_SUCCESS
      });
      toast.success("Mass bills Rollback updated successfully", { position: "top-center" });
      dispatch(fetchBills());
    } else {
      throw new Error('Failed to update mass bill approvals');
    }
  } catch (error) {
    dispatch({
      type: UPDATE_MASSBILLS_ROLLBACK_ERROR,
      payload: error.message,
    });
    toast.error(error.message, { position: "top-center" });
  }
};

export const updateFlagStatus = (billId, flagStatus) => async (dispatch) => {
  dispatch(updateBillFlagRequest());
  try {
    const token = getToken();
    const response = await axios.put(`${baseUrl}/updateFlagStatus`, {
      billId,
      flagStatus
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    dispatch(updateBillFlagSuccess({ billId, flagStatus }));
    toast.success("Bill flag status updated successfully", { position: "top-center" });
  } catch (error) {
    dispatch(updateBillFlagFailure(error.message));
    toast.error(error.response?.data?.message || "Error updating bill flag status", { position: "top-center" });
  }
};
export const deleteBillRequest = () => ({
  type: DELETE_BILL_REQUEST,
});
export const deleteBillSuccess = (bill_id) => ({
  type: DELETE_BILL_SUCCESS,
  payload: bill_id,
});
export const deleteBillFailure = (error) => ({
  type: DELETE_BILL_ERROR,
  payload: error.message,
});
export const deleteBill = (bill_id) => {
  return async (dispatch) => {
    dispatch(deleteBillRequest());
    try {
      const token = getToken();
      const response = await axios.delete(`${baseUrl}/bill/${bill_id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      dispatch(deleteBillSuccess(bill_id));
      toast.success("Bill deleted successfully", { position: "top-center" });
    } catch (error) {
      dispatch(deleteBillFailure(error.message));
    }
  };
};


export const setAllBillsForReport = (bills) => ({
  type: SET_ALL_BILLS_FOR_REPORT,
  payload: bills,
});


